import React from "react";
import Heading from "../Heading/Heading";
import "./About.css";

const About = () => {
  return (
    <section id="about">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <Heading title1="About Me" title2="Know Me More" />
          </div>
          <div className="col-lg-8 col-md-8">
            <h4 className="text-8 mt-5">
              Hi, I'M
              <span className="bold bottom-border border-3 primary-border ms-3">
                Nazmul Hasan Nannu
              </span>
            </h4>
            <p className="text-5 lh-2 mt-4 res-text">
              I'm a designer & developer with a passion for web design. I enjoy
              developing simple, clean and slick websites that provide real
              value to the end user. Thousands of clients have procured
              exceptional results while working with me. Delivering work within
              time and budget which meets client’s requirements is our moto.
            </p>
          </div>
          <div className="col-lg-4 col-md-4 mt-5">
            <div className="feature-box-icon primary-bg rounded-circle">
              <span className="exp-yr">1+</span>
            </div>
            <h3 className="text-center mt-4">
              Years of <span className="bold">Experience</span>
            </h3>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
